import { Check } from 'lucide-react';

type NavigatorResultsStepperProps = {
  /** Step-2 label: "Your Matches" (FP) or "Your Care Guide" (care-seeker). */
  step2Label?: string;
};

/**
 * Two-step "Your Story -> ..." indicator that sits in the results-page header,
 * matching the FP results page (ResultsPageChrome.Stepper). Step 1 is always
 * complete (just finished) and step 2 is the current results view.
 */
export const NavigatorResultsStepper = ({
  step2Label = 'Your Matches',
}: NavigatorResultsStepperProps) => (
  <div className="flex items-center gap-3 text-sm">
    <span className="flex items-center gap-2 text-text-secondary">
      <span className="flex h-6 w-6 items-center justify-center rounded-full bg-sage text-white">
        <Check className="h-3 w-3" aria-hidden />
      </span>
      Your Story
    </span>
    <span className="h-px w-12 bg-border-subtle" aria-hidden />
    <span className="flex items-center gap-2 font-medium text-text-primary">
      <span className="flex h-6 w-6 items-center justify-center rounded-full bg-sage text-xs font-semibold text-white">
        2
      </span>
      {step2Label}
    </span>
  </div>
);
